import artsColors from './artsColors'
import economyColors from './economyColors'
import globalizedColors from './globalizedColors'
import languageColors from './languageColors'
import mathsColors from './mathsColors'
import musicalArtsEducationColors from './musicalArtsEducationColors'
import naturalScienceColors from './naturalScienceColors'
import philosophyColors from './philosophyColors'
import physicalColors from './physicalColors'
import religionColors from './religionColors'
import socialScienceColors from './socialScienceColors'
import technoColors from './technologyColors'
import valuesColors from './valuesColors'

const subjectColors = {
  ...socialScienceColors,
  ...naturalScienceColors,
  ...mathsColors,
  ...valuesColors,
  ...languageColors,
  ...musicalArtsEducationColors,
  ...globalizedColors,
  ...religionColors,
  ...artsColors,
  ...economyColors,
  ...philosophyColors,
  ...physicalColors,
  ...technoColors,
}

export default subjectColors
